import { searchAPI } from "../../api/searchAPI"
import { isFetchingAC } from "../actions/searchActions"
import { getRecommendationsAC, GET_ARTISTS, IS_FETCHING, searchArtistAC, SEARCH_ARTIST } from "../actions/searchActions"

let initialState = {
    recommendedArtists: null,
    artist: null,
    isFetching: false
}

export const searchReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_ARTISTS:
            return {
                ...state,
                recommendedArtists: action.artists
            }
        case SEARCH_ARTIST: {
            return {
                ...state,
                artist: action.isFound ? action.artist : null
            }
        }
        case IS_FETCHING:
            return {
                ...state,
                isFetching: action.isFetching
            }
    }
    return state
}

export const getRecommendations = () => async (dispatch) => {
    try {
        let artists = await searchAPI.getRecommendations()
        dispatch(getRecommendationsAC(artists))
    } catch (e) {
        throw e
    }
}

export const searchArtist = (enteredArtist) => async (dispatch) => {
    try {
        dispatch(isFetchingAC(true))
        let isFound = await searchAPI.searchArtist(enteredArtist)
        dispatch(searchArtistAC(enteredArtist, isFound))
        dispatch(isFetchingAC(false))
    } catch (e) {
        throw e
    } finally {
        dispatch(isFetchingAC(false))
    }
}